import SingleTask from "./singleTask";

const SingleWorkLine = ({
  work,
  emptyBox,
  setShowMemberBox,
  setActiveTask,
  setSelectedAssignees,
  removeTaskAssignee,
}) => {
  return (
    <div className="team-grid-right team-relative-line">
      <div className="team-work-grid-task-absolute-box">
        <div className="fc team-single-work-flex">
          {work?.workTasks?.map((task, ind) => (
            <SingleTask
              key={ind}
              ind={ind}
              task={task}
              setActiveTask={setActiveTask}
              setShowMemberBox={setShowMemberBox}
              setSelectedAssignees={setSelectedAssignees}
              removeTaskAssignee={removeTaskAssignee}
            />
          ))}
        </div>
      </div>
      {emptyBox.map((_, i) => (
        <div
          className="team-left-taskname-box"
          style={{
            zIndex: "0",
            height: `${work?.workTasks?.length * 18 + 28 + work?.workTasks?.length * 5}px`,
          }}
          key={i}
        ></div>
      ))}
    </div>
  );
};

export default SingleWorkLine;
